export default {
    // Header Section
    "discover_your": "మీ",
    "lal_kitab": "లాల్ కితాబ్",
    "ancient_remedial_wisdom": "ప్రాచీన పరిహార జ్ఞానం",
    "lal_kitab_description": "వ్యక్తిగత లాల్ కితాబ్ విశ్లేషణతో ప్రాచీన జ్ఞాన లోకంలో అడుగుపెట్టండి. దాచిన కర్మ నమూనాలను బయటపెట్టండి, జీవిత రహస్యాలను అర్థం చేసుకోండి, సవాళ్లను విజయం, సామరస్యం మరియు శ్రేయస్సు కోసం అవకాశాలుగా మార్చడానికి సాధారణమైన, శక్తివంతమైన పరిహారాలను తెలుసుకోండి.",

    "craft_your_destiny": "లాల్ కితాబ్ ఆధారంగా ",
    "lal_kitab_title": "మీ విధి విశ్లేషణను పొందండి",

    // Service Information
    "enter_details_for_lal_kitab": "లాల్ కితాబ్ విశ్లేషణ కోసం మీ వివరాలు నమోదు చేయండి",
    "complete_lal_kitab_analysis": "పూర్తి లాల్ కితాబ్ విశ్లేషణ",
    "service_price": "సేవా మూల్యం",
    "comprehensive_lal_kitab_analysis_note": "ఆచరణాత్మక పరిహారాలు మరియు కార్మిక మార్గదర్శకత్వంతో వివరమైన లాల్ కితాబ్ చార్ట్ విశ్లేషణ",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరు నమోదు చేయండి",
    "name_lal_kitab_influence": "మీ పేరు లాల్ కితాబ్‌లో కార్మిక నమూనాలు మరియు పరిహార ప్రభావకారిత్వాన్ని ప్రభావితం చేస్తుంది",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామా నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబర్ నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_lal_kitab_chart": "ఖచ్చితమైన లాల్ కితాబ్ చార్ట్ మరియు గ్రహ విశ్లేషణ సృష్టించడానికి అవసరం",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_lal_kitab_houses": "లాల్ కితాబ్ వ్యవస్థలో ఖచ్చితమైన గృహ స్థానాలకు ఖచ్చితమైన సమయం అవసరం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "location_lal_kitab_analysis": "స్థానం గ్రహ స్థానాలు మరియు లాల్ కితాబ్ చార్ట్ లెక్కలను ప్రభావితం చేస్తుంది",
    "preferred_language": "ఇష్టపడే భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ లాల్ కితాబ్ విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Lal Kitab Features
    "lal_kitab_chart_analysis": "లాల్ కితాబ్ చార్ట్ విశ్లేషణ",
    "planetary_positions_lal_kitab": "లాల్ కితాబ్‌లో గ్రహ స్థానాలు",
    "practical_remedies_solutions": "ఆచరణాత్మక పరిహారాలు & పరిష్కారాలు",
    "karmic_debts_analysis": "కార్మిక రుణాల విశ్లేషణ",
    "life_predictions_guidance": "జీవిత భవిష్యవాణులు & మార్గదర్శకత్వం",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ లాల్ కితాబ్ విశ్లేషణలో ఉన్నవి",
    "complete_lal_kitab_chart": "పూర్తి లాల్ కితాబ్ చార్ట్",
    "practical_remedial_measures": "ఆచరణాత్మక పరిహార చర్యలు",
    "karmic_analysis_guidance": "కార్మిక విశ్లేషణ & మార్గదర్శకత్వం",
    "life_predictions_insights": "జీవిత భవిష్యవాణులు & అంతర్దృష్టులు",

    // Actions & Buttons
    "pay_and_get_lal_kitab_analysis": "నా లాల్ కితాబ్ విశ్లేషణ పొందండి",
    "processing_payment": "చెల్లింపు ప్రాసెస్ చేస్తున్నాము",
    "processing_request": "విశ్లేషణ తయారు చేస్తున్నాము",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "lal_kitab_analysis_processing": "మీ సమగ్ర లాల్ కితాబ్ విశ్లేషణ మా నిపుణ లాల్ కితాబ్ జ్యోతిష్కులచే తయారు చేయబడుతోంది. మీరు ఆచరణాత్మక పరిహారాలు మరియు కార్మిక అంతర్దృష్టులతో వివరమైన చార్ట్ విశ్లేషణను పొందుతారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "పేమెంట్ ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_24_hours_delivery_note": "మీ వివరమైన లాల్ కితాబ్ విశ్లేషణ 24 గంటలలోపు సిద్ధంగా ఉంటుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్లు పొందండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ డెలివర్ చేయబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ లాల్ కితాబ్ విశ్లేషణ ప్యాకేజీ",
    "detailed_lal_kitab_report": "వివరమైన లాల్ కితాబ్ నివేదిక (PDF)",
    "lal_kitab_chart_analysis": "లాల్ కితాబ్ చార్ట్ విశ్లేషణ",
    "practical_remedies_list": "ఆచరణాత్మక పరిహారాల జాబితా",
    "karmic_debts_solutions": "కార్మిక రుణాలు & పరిష్కారాలు",
    "life_guidance_predictions": "జీవిత మార్గదర్శకత్వం & భవిష్యవాణులు",

    // Visual Content
    "sample_lal_kitab_analysis": "నమూనా లాల్ కితాబ్ విశ్లేషణ",
    "lal_kitab_house_analysis": "లాల్ కితాబ్ గృహ విశ్లేషణ",
    "sample_lal_kitab_reading": "ఆచరణాత్మక పరిహార పరిష్కారాలతో బలమైన గ్రహ స్థానాలు",
    "sample_lal_kitab_preview": "పరిహార మార్గదర్శకత్వంతో మీ వ్యక్తిగత లాల్ కితాబ్ విశ్లేషణ ప్రివ్యూ",
    "lal_kitab_houses": "లాల్ కితాబ్ గృహాలు",

    // House Types
    "self": "స్వయం",
    "wealth": "ధనం",
    "siblings": "సోదరులు",
    "mother": "తల్లి",
    "children": "పిల్లలు",
    "enemies": "శత్రువులు",
    "spouse": "జీవిత భాగస్వామి",
    "longevity": "దీర్ఘాయువు",
    "father": "తండ్రి",
    "career": "కెరీర్",
    "gains": "లాభాలు",
    "expenses": "ఖర్చులు",

    // Status & Processing
    "your_lal_kitab_analysis_status": "మీ లాల్ కితాబ్ విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ లాల్ కితాబ్ చార్ట్ విశ్లేషిస్తున్నాము",
    "analysis_processing_message": "మా నిపుణ లాల్ కితాబ్ జ్యోతిష్కులు ఆచరణాత్మక పరిహారాలు మరియు కార్మిక అంతర్దృష్టులతో ఖచ్చితమైన విశ్లేషణను అందించడానికి మీ జన్మ కుండలిని అధ్యయనం చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో",
    "pending": "వేచి ఉన్న",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్లు ప్రారంభించబడ్డాయి",
    "delivery_within_24_hours": "నివేదిక 24 గంటలలో సిద్ధం",

    // Support & Contact
    "contact_support": "లాల్ కితాబ్ మద్దతు సంప్రదించండి",
    "need_help": "మార్గదర్శకత్వం అవసరమా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అన్ని అవసరమైన జన్మ వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Lal Kitab Specific Elements
    "planetary_debts": "గ్రహ రుణాలు",
    "karmic_accounts": "కార్మిక ఖాతాలు",
    "ancestral_karma": "పూర్వీకుల కర్మ",
    "past_life_debts": "పూర్వజన్మ రుణాలు",
    "family_karma": "కుటుంబ కర్మ",
    "collective_karma": "సామూహిక కర్మ",

    // Planets in Lal Kitab
    "sun_lal_kitab": "లాల్ కితాబ్‌లో సూర్యుడు",
    "moon_lal_kitab": "లాల్ కితాబ్‌లో చంద్రుడు",
    "mars_lal_kitab": "లాల్ కితాబ్‌లో అంగారకుడు",
    "mercury_lal_kitab": "లాల్ కితాబ్‌లో బుధుడు",
    "jupiter_lal_kitab": "లాల్ కితాబ్‌లో గురువు",
    "venus_lal_kitab": "లాల్ కితాబ్‌లో శుక్రుడు",
    "saturn_lal_kitab": "లాల్ కితాబ్‌లో శనిని",
    "rahu_lal_kitab": "లాల్ కితాబ్‌లో రాహువు",
    "ketu_lal_kitab": "లాల్ కితాబ్‌లో కేతువు",

    // Remedial Categories
    "simple_remedies": "సాధారణ గృహ పరిహారాలు",
    "donation_remedies": "దానం & దాతృత్వ పరిహారాలు",
    "feeding_remedies": "భోజనం & సేవ పరిహారాలు",
    "water_remedies": "నీరు సంబంధిత పరిహారాలు",
    "clothing_remedies": "దుస్తులు & రంగు పరిహారాలు",
    "behavioral_remedies": "ప్రవర్తన మార్పు పరిహారాలు",

    // Types of Debts
    "pitra_rin": "పితృ రిణం (పూర్వీకుల రుణం)",
    "matru_rin": "మాతృ రిణం (తల్లి రుణం)",
    "stree_rin": "స్త్రీ రిణం (భార్య రుణం)",
    "bhratru_rin": "భ్రాతృ రిణం (సోదర రుణం)",
    "putra_rin": "పుత్ర రిణం (కుమారుడి రుణం)",
    "guru_rin": "గురు రిణం (గురువు రుణం)",

    // Lal Kitab Concepts
    "blind_planets": "గుడ్డి గ్రహాలు",
    "lame_planets": "కుంటి గ్రహాలు",
    "sleeping_planets": "నిద్రాణమైన గ్రహాలు",
    "deceased_planets": "మృత గ్రహాలు",
    "enemy_planets": "శత్రు గ్రహాలు",
    "friend_planets": "మిత్రు గ్రహాలు",

    // House Analysis
    "first_house": "1వ గృహం - వ్యక్తిత్వం & స్వయం",
    "second_house": "2వ గృహం - ధనం & కుటుంబం",
    "third_house": "3వ గృహం - సోదరులు & కమ్యూనికేషన్",
    "fourth_house": "4వ గృహం - తల్లి & ఆస్తి",
    "fifth_house": "5వ గృహం - పిల్లలు & విద్య",
    "sixth_house": "6వ గృహం - శత్రువులు & ఆరోగ్యం",
    "seventh_house": "7వ గృహం - వివాహం & భాగస్వామ్యం",
    "eighth_house": "8వ గృహం - దీర్ఘాయువు & మాంత్రిక",
    "ninth_house": "9వ గృహం - తండ్రి & అదృష్టం",
    "tenth_house": "10వ గృహం - కెరీర్ & హోదా",
    "eleventh_house": "11వ గృహం - లాభాలు & స్నేహితులు",
    "twelfth_house": "12వ గృహం - ఖర్చులు & విదేశీ",

    // Planetary Strengths
    "strong_planets": "బలమైన గ్రహాలు",
    "weak_planets": "బలహీన గ్రహాలు",
    "malefic_planets": "పాప గ్రహాలు",
    "benefic_planets": "శుభ గ్రహాలు",
    "neutral_planets": "తటస్థ గ్రహాలు",
    "exalted_planets": "ఉచ్చ గ్రహాలు",

    // Remedy Types
    "immediate_remedies": "తక్షణ ప్రభావ పరిహారాలు",
    "long_term_remedies": "దీర్ఘకాలిక పరిహారాలు",
    "emergency_remedies": "అత్యవసర పరిహారాలు",
    "preventive_remedies": "నివారణ పరిహారాలు",
    "corrective_remedies": "సరిదిద్దే పరిహారాలు",
    "protective_remedies": "రక్షణ పరిహారాలు",

    // Life Areas Analysis
    "health_analysis": "ఆరోగ్య విశ్లేషణ",
    "wealth_analysis": "ధన విశ్లేషణ",
    "career_analysis": "కెరీర్ విశ్లేషణ",
    "marriage_analysis": "వివాహ విశ్లేషణ",
    "children_analysis": "పిల్లల విశ్లేషణ",
    "property_analysis": "ఆస్తి విశ్లేషణ",

    // Timing Analysis
    "favorable_periods": "అనుకూల కాలాలు",
    "challenging_periods": "సవాలు కాలాలు",
    "remedy_timing": "పరిహారం అమలు సమయం",
    "result_timing": "ఆశించిన ఫలిత సమయం",
    "life_phases": "ప్రధాన జీవిత దశలు",
    "turning_points": "జీవిత మలుపు బిందువులు",

    // Special Features
    "curse_analysis": "శాపం & నెగటివ్ శక్తి విశ్లేషణ",
    "blessing_analysis": "ఆశీర్వాదాలు & పాజిటివ్ శక్తి",
    "family_tree_karma": "కుటుంబ వృక్ష కర్మ విశ్లేషణ",
    "generational_patterns": "తరానుతర కర్మ నమూనాలు",
    "soul_purpose": "ఆత్మ లక్ష్యం & జీవిత మిషన్",
    "spiritual_evolution": "ఆధ్యాత్మిక పరిణామ మార్గం",

    // Practical Applications
    "daily_remedies": "దైనందిన పరిహారాలు",
    "weekly_remedies": "వారపు పాలనలు",
    "monthly_remedies": "నెలవారీ అభ్యాసాలు",
    "annual_remedies": "వార్షిక పాలనలు",
    "special_occasion_remedies": "ప్రత్యేక సందర్భ పరిహారాలు",
    "festival_remedies": "పండుగ ఆధారిత పరిహారాలు",

    // Modern Adaptations
    "urban_remedies": "పట్టణ జీవన అనుకూలతలు",
    "office_remedies": "కార్యాలయ పరిహారాలు",
    "travel_remedies": "ప్రయాణం & యాత్ర పరిహారాలు",
    "technology_remedies": "ఆధునిక సాంకేతిక పరిహారాలు",
    "social_media_remedies": "డిజిటల్ యుగ పరిహారాలు",
    "global_living_remedies": "అంతర్జాతీయ జీవన అనుకూలతలు",

    // Consultation Features
    "expert_consultation": "నిపుణ లాల్ కితాబ్ సంప్రదింపు",
    "follow_up_guidance": "అనుసరణ పరిహార మార్గదర్శకత్వం",
    "progress_tracking": "పరిహార పురోగతి ట్రాకింగ్",
    "customization": "వ్యక్తిగత పరిహార కస్టమైజేషన్",
    "update_analysis": "నవీకరించిన విశ్లేషణ ఎంపికలు",
    "family_analysis": "కుటుంబ చార్ట్ విశ్లేషణ",

    // Advanced Concepts
    "paap_planets": "పాప (పాపకర్మ) గ్రహాలు",
    "punya_planets": "పుణ్య (సత్కర్మ) గ్రహాలు",
    "raja_yoga": "లాల్ కితాబ్‌లో రాజ యోగం",
    "dhana_yoga": "ధన యోగ కలయికలు",
    "vipreet_raja_yoga": "విప్రీత రాజ యోగం",
    "neech_bhang_yoga": "నీచ భంగ యోగం",

    // Unique Lal Kitab Rules
    "pakka_ghar": "పక్కా గృహం (శాశ్వత గృహం)",
    "kachha_ghar": "కచ్చా గృహం (తాత్కాలిక గృహం)",
    "mool_trikona": "లాల్ కితాబ్‌లో మూల త్రికోణం",
    "own_house": "స్వగృహ స్థానం",
    "friendly_house": "మిత్రు గృహ స్థానం",
    "enemy_house": "శత్రు గృహ స్థానం"
};
